import template from './employee_attendance_information_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeeAttendanceInformationHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeAttendanceInformationHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeAttendanceInformationHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeeAttendanceInformationHelp',
	dialog_class: EmployeeAttendanceInformationHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_attendance_information_help',
	provider: 'ps'
};
